<template>
  <div class="userManage">
    <div class="show_user">
      <div class="notUser" v-if="show_data==null ||  Object.keys(show_data).length===0">暂无用户</div>
      <div class="show_uesr_content" v-else>
        <div class="searchWrap">
          <div class="search_input">
            <Search v-model="search_val" :clearable="false" @update:model-value="search_query"></Search>
          </div>
          <div class="search_list" v-if="actions.length>0">
            <div class="searchItem" v-for="(item,i) in actions" :key="i" @click="select_search(item)">{{ item.username }}</div>
          </div>
        </div>
        <div class="tableWrap">
          <div class="tableHeader">
            <span>省份</span>
            <span>店铺名称</span>
            <span>被授权人</span>
            <span>授权证书编号</span>
            <span>授权日期</span>
            <span>操作</span>
          </div>
          <div class="tableBody">
            <div class="tableRow" v-for="(item,i) in show_data" :key="i" :class="{'searchbg':search_bg==i}">
              <span v-for="(items,a) in item" :key="a">{{ items }}</span>
              <span class="rowActions"><span class="actionBtn del" @click="delUser(item)">删除</span> <span class="actionBtn edit" @click="modifyUser(item)">修改</span></span>
            </div>
          </div>
        </div>
      </div>
      <div class="addBtn" @click="sub_overlay=true">+</div>
    </div>
    <div class="userManage_buttom" v-if="show_data != null">
      <Pagination v-model="totalPage" :total-items="pageInfo.total_items" :items-per-page="pageInfo.items_per_page" @change="cahangePage" v-if="pageInfo.total_items>10"/>
      <span class="totalCount">共: {{((totalPage-1)*15+show_data.length)}}/{{pageInfo.total_items}}</span>
    </div>
    <Overlay :show="sub_overlay" @click="sub_overlay = false">
      <div class="overlayWrapper" @click.stop>
        <div class="add_user_overlay">
          <Loading color="#1989fa" vertical  v-if="upLoad_loading">上传中...</Loading>
          <div class="add_userType">
            <div class="typeTab" :class="{'active':add_user_type==1}" @click="upLoad_barChange(1)">单条</div>
            <div class="typeTab" :class="{'active':add_user_type==2}" @click="upLoad_barChange(2)">excel导入</div>
          </div>
          <div class="one_data" v-if="add_user_type==1">
            <Form @submit="submitUserInfo">
              <Field :rules="[{ required: true, message: '请填写省份' }]" placeholder="省份（必填）" type="text" v-model="oneDateInfo.province"></Field>
              <Field :rules="[{ required: true, message: '请填写店铺名称' }]" placeholder="店铺名称（必填）" type="text" v-model="oneDateInfo.shopsName"></Field>
              <Field :rules="[{ required: true, message: '请填写被授权人' }]" placeholder="被授权人（必填）" type="text" v-model="oneDateInfo.userName"></Field>
              <Field :rules="[{ required: true, message: '请填写授权证书编号' }]" placeholder="授权证书编号（必填）" type="text" v-model="oneDateInfo.codeNum"></Field>
              <Field :rules="[{ required: true, message: '请填写授权日期' }]" placeholder="授权日期（必填）" type="text" v-model="oneDateInfo.time"></Field>
              <Button type="primary" size="large" class="submit" native-type="submit">提交</Button>
            </Form>
          </div>
          <div class="all_data" v-else>
            <input type="file" accept=".xls,.xlsx" @change="handleFileUpload" class="fileUploader"/>
          </div>
        </div>
      </div>
      <div class="allData_list" v-if="excelData.length!=0" @click.stop>
        <Loading color="#1989fa" vertical v-if="upLoad_loading">上传中...</Loading>
        <div class="allList_title">合作商信息登记</div>
        <div class="allData_list_close" @click="excelData=[]">&times;</div>
        <div class="excelTable">
          <div class="excelHeader">
            <span>省份</span>
            <span>店铺名称</span>
            <span>被授权人</span>
            <span>授权证书编号</span>
            <span>授权日期</span>
          </div>
          <div class="excelBody">
            <div class="excelRow" v-for="(item,i) in excelData" :key="i">
              <span v-for="(items,a) in item" :key="a">{{ items }}</span>
            </div>
          </div>
        </div>
        <Button type="primary" size="small" class="all_submit" @click="excel_Btn">提交</Button>
      </div>
    </Overlay>
  <!-- 修改用户数据 -->
  <Overlay :show="modify_isShow">
    <div class="modify_user" @click.stop>
      <div class="closeModify" @click="closeModify">&times;</div>
      <div class="modify_uer_title">修改用户</div>
      <Form @submit="sub_modifyUser">
        <Field :rules="[{ required: true, message: '请填写被授权人' }]" placeholder="被授权人（必填）" type="text" v-model="modify_user_data.userName"></Field>
        <Field :rules="[{ required: true, message: '请填写省份' }]" placeholder="省份（必填）" type="text" v-model="modify_user_data.province"></Field>
        <Field :rules="[{ required: true, message: '请填写店铺名称' }]" placeholder="店铺名称（必填）" type="text" v-model="modify_user_data.shopsName"></Field>
        <Field :rules="[{ required: true, message: '请填写授权证书编号' }]" placeholder="授权证书编号（必填）" type="text" v-model="modify_user_data.codeNum"></Field>
        <Field :rules="[{ required: true, message: '请填写授权日期' }]" placeholder="授权日期（必填）" type="text" v-model="modify_user_data.time"></Field>
        <Button type="primary" size="large" class="submit" native-type="submit">提交</Button>
      </Form>
    </div>
  </Overlay>
  </div>
</template>
<script setup>
import { computed, getCurrentInstance, onMounted, ref } from 'vue';
import { Overlay, Field, Button, Search, Popover, showToast, Pagination, Form, Uploader, Loading, showLoadingToast } from 'vant'
import { useRouter } from 'vue-router';
import { update_strip, update_excel, getDataCount, getAuthAll } from '@/api/index'
import 'vant/lib/index.css';
import * as XLSX from 'xlsx';

const page = getCurrentInstance()
const search_val = ref('')
const search_bg = ref(-1)
const modify_user_data = ref()
const modify_isShow = ref(false)
const sub_overlay = ref(false)
const add_user_type = ref(1)
const show_data = ref({})
const oneDateInfo = ref({
  province: '',
  shopsName: '',
  userName: '',
  codeNum: '',
  time: ''
})
const actions = ref([]);
const excelData = ref([])
const dataTotal = ref(0)
const totalPage = ref(1)
const pageInfo = ref({
  items_per_page: 15,
  total_items: 0,
  show_page_size: 10
})
onMounted(async () => {
  let countRes = await getDataCount()
  dataTotal.value = countRes.data
  pageInfo.value.total_items = countRes.data
  getShow_authData()
})
const search_query = async () => {
  const textLeg = /[\u4e00-\u9fff]/
  if (search_val.value == '') {
    actions.value = []
  }
  if (!textLeg.test(search_val.value)) {
    return
  }
  let res = await page.proxy.$apiGet('/vagueQuery', { userName: search_val.value })
  actions.value = [...res.data]
}
const select_search = async (item) => {
  let target_index = Math.ceil(item.target_index / 15)
  totalPage.value = target_index
  getShow_authData()
  actions.value = []
  search_val.value = ''
  search_bg.value = (item.target_index - 1) % 15
}
const upLoad_loading = ref(false)
const submitUserInfo = () => {
  const textLeg = /[\u4e00-\u9fff]/
  if (!textLeg.test(oneDateInfo.value.province)) {
    oneDateInfo.value.province = ''
    showToast('省份仅支持汉字')
    return
  }
  if (!textLeg.test(oneDateInfo.value.userName)) {
    showToast('被授权人仅支持汉字')
    oneDateInfo.value.userName = ''
    return
  }
  const integerRegex = /^\d+$/;
  if (!integerRegex.test(oneDateInfo.value.codeNum)) {
    showToast('授权码仅支持纯数字')
    oneDateInfo.value.codeNum = ''
    return
  }
  if (!checkValueType(oneDateInfo.value.time)) {
    showToast('日期格式有误')
    oneDateInfo.value.time = ''
    return
  }
  upLoad_loading.value = true
  setTimeout(async () => {
    await update_strip({ ...oneDateInfo.value })
    getShow_authData()
    upLoad_loading.value = false
    sub_overlay.value = false
    oneDateInfo.value.province = ''
    oneDateInfo.value.userName = ''
    oneDateInfo.value.shopsName = ''
    oneDateInfo.value.codeNum = ''
    oneDateInfo.value.time = ''
  }, 500)
}
const upLoad_barChange = (item) => {
  if (upLoad_loading.value) { return }
  add_user_type.value = item
}
const handleFileUpload = (event) => {
  let excel_data_loading = showLoadingToast({
    message: 'excel解析中...',
    loadingType: 'spinner',
    duration: 0
  });
  const file = event.target.files[0];
  const reader = new FileReader();
  reader.onload = (e) => {
    const data = new Uint8Array(e.target.result);
    const workbook = XLSX.read(data, { type: 'array' });
    const firstSheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[firstSheetName];
    const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 })
    const filteredData = jsonData.filter(row => row.length > 0);
    let headers = filteredData[0]
    let index = 0
    for (let i = 0; i < headers.length; i++) {
      if (headers[i] === '地区') { index = i }
    }
    let lastIsTime = false
    if (headers[headers.length - 1] == '授权编码') {
      lastIsTime = true
    }
    let timeIndex = 0
    for (let i = 0; i < headers.length; i++) {
      if (headers[i] == '授权日期') {
        timeIndex = i
      }
    }
    const cleanedData = filteredData.map(row => row.slice(index));
    let trimmedData = cleanedData.slice(1);
    trimmedData = trimmedData.map(row => row.slice(0));
    if (lastIsTime) {
      trimmedData.map(row => {
        var arr = row;
        var temp = arr[arr.length - 1];
        arr[arr.length - 1] = arr[arr.length - 2];
        arr[arr.length - 2] = temp;
        row = arr
      })
    }
    trimmedData.map(row => {
      for (let i = 0; i < row.length; i++) {
        if (i == 4) {
          var numericPattern = /^\d+$/;
          if (numericPattern.test(row[i])) {
            row[i] = excelDateToJSDate(row[i])
          }
        }
      }
    });
    excel_data_loading.close()
    if (trimmedData.length == 0) {
      showToast('该表格无数据，请重新选择')
      return
    }
    excelData.value = trimmedData
  };
  reader.readAsArrayBuffer(file);
}
const excel_Btn = async () => {
  show_data.value = excelData.value
  upLoad_loading.value = true
  for (let i = 0; i < excelData.value.length; i++) {
    let res = await update_excel(excelData.value[i])
    if (res.data == '已存在') {
      showToast('授权码:' + excelData.value[i][3] + '已存在')
      upLoad_loading.value = false
    }
  }
  getShow_authData()
  setTimeout(() => {
    excelData.value = [];
    sub_overlay.value = false;
    upLoad_loading.value = false
  }, 500)
}
const getShow_authData = async () => {
  let authListRes = await getAuthAll({ pageNum: totalPage.value })
  show_data.value = authListRes.data.rows
}
const cahangePage = async () => {
  getShow_authData()
  search_bg.value = -1
}
const isNumeric = (value) => {
  return !isNaN(parseFloat(value)) && isFinite(value);
}
const isDateStr = (value) => {
  const dateFormats = [/^\d{4}\/\d{1,2}\/\d{1,2}$/, /^\d{4}\.\d{1,2}\.\d{1,2}$/, /^\d{4}-\d{1,2}-\d{1,2}$/];
  for (let format of dateFormats) {
    if (format.test(value)) {
      return true;
    }
  }
  return false;
}
const checkValueType = (value) => {
  if (isNumeric(value)) {
    return false;
  } else if (isDateStr(value)) {
    return true;
  } else {
    return false;
  }
}
const delUser = (item) => {
  const isDel = confirm('是否确认删除,数据删除后将无法恢复')
  if (isDel) {
    let delUserLoading = showLoadingToast({
      message: '删除中...',
      loadingType: 'spinner',
      duration: 0
    });
    setTimeout(async () => {
      let res = await page.proxy.$apiGet('/deluser', { codenum: item.codeNum })
      if (res.data == 1) {
        showToast('删除成功')
      } else {
        showToast('删除失败')
      }
      delUserLoading.close()
      getShow_authData()
    }, 300)
  }
}
const modifyUser = (item) => {
  let modify_data = item
  modify_isShow.value = true
  modify_user_data.value = modify_data
  modify_user_data.value.notCodeNum = modify_data.codeNum
}
const sub_modifyUser = async () => {
  let modiUserLoading = showLoadingToast({
    message: '更新中...',
    loadingType: 'spinner',
    duration: 0
  });
  setTimeout(async () => {
    let res = await page.proxy.$apiGet('/modifyUser', { ...modify_user_data.value })
    showToast('修改成功')
    modiUserLoading.close()
    getShow_authData()
    modify_isShow.value = false
    modify_user_data.value = []
  }, 300)
  getShow_authData()
}
const closeModify = async () => {
  getShow_authData()
  modify_isShow.value = false
  modify_user_data.value = []
}

const excelDateToJSDate = (excelDate) => {
  const startDate = new Date(1900, 0, 1);
  startDate.setDate(startDate.getDate() + excelDate);
  var year = startDate.getFullYear();
  var month = startDate.getMonth() + 1;
  month = month > 10 ? month : '0' + month
  var day = startDate.getDate();
  day = day > 10 ? day : '0' + day
  return `${year}-${month}-${day}`
}
</script>
<style scoped>
/* 全局滚动条样式 */
.userManage ::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}
.userManage ::-webkit-scrollbar-track {
  background: #f0f0f0;
  border-radius: 2px;
}
.userManage ::-webkit-scrollbar-thumb {
  background: #818cf8;
  border-radius: 2px;
}
.userManage ::-webkit-scrollbar-thumb:hover {
  background: #6366f1;
}

.userManage {
  width: 100%;
  height: 100%;
  user-select: none;
}

.show_user {
  width: 100%;
  height: 100%;
  position: relative;
  background: #f7f8fa;
  overflow: hidden;
}
.notUser {
  position: absolute;
  left: 50%;
  top: 50%;
  font-size: 18px;
  color: #bbb;
  transform: translate(-50%, -50%);
}
.show_uesr_content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* 搜索区域 */
.searchWrap {
  padding: 16px 20px;
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
}
.search_input {
  max-width: 400px;
  margin: 0 auto;
}
.search_input :deep(.van-search) {
  padding: 0;
  background: #fff;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  overflow: hidden;
  transition: border-color 0.2s;
}
.search_input :deep(.van-search):hover {
  border-color: #818cf8;
}
.search_input :deep(.van-search__content) {
  background: #fff;
  padding: 0 8px;
}
.search_input :deep(.van-field__control) {
  color: #333;
  font-size: 14px;
}
.search_list {
  max-width: 400px;
  margin: 8px auto 0;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  font-size: 14px;
  max-height: 240px;
  overflow: auto;
}
.searchItem {
  cursor: pointer;
  padding: 10px 16px;
  transition: background 0.2s;
}
.searchItem:hover {
  background: #f7f8fa;
}

/* 表格区域 */
.tableWrap {
  flex: 1;
  overflow: auto;
  padding: 0 20px 20px;
}
.tableHeader {
  display: flex;
  background: #f7f8fa;
  padding: 12px 0;
  font-size: 13px;
  font-weight: 600;
  color: #555;
  position: sticky;
  top: 0;
  /* z-index: 5; */
  border-radius: 8px 8px 0 0;
}
.tableHeader span {
  flex: 1;
  text-align: center;
  padding: 0 8px;
}
.tableHeader span:last-child {
  flex: 0.8;
}
.tableBody {
  background: #fff;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}
.tableRow {
  display: flex;
  align-items: center;
  padding: 0;
  border-bottom: 1px solid #f0f0f0;
  min-height: 48px;
  transition: background 0.2s;
  cursor: pointer;
}
.tableRow:last-child {
  border-bottom: none;
}
.tableRow:hover {
  background: #dbeafe !important;
  box-shadow: inset 3px 0 0 #4f46e5;
}
.tableRow span {
  flex: 1;
  text-align: center;
  font-size: 13px;
  color: #333;
  padding: 12px 8px;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tableRow span:last-child {
  flex: 0.8;
}
.rowActions {
  display: flex;
  gap: 8px;
  justify-content: center;
}
.actionBtn {
  font-size: 13px;
  cursor: pointer;
  transition: color 0.2s;
}
.actionBtn.del {
  color: #ef4444;
}
.actionBtn.del:hover {
  color: #dc2626;
}
.actionBtn.edit {
  color: #4f46e5;
}
.actionBtn.edit:hover {
  color: #4338ca;
}
.searchbg {
  background: #e0e7ff !important;
}

/* 底部区域 */
.userManage_buttom {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  background: #fff;
  border-top: 1px solid #f0f0f0;
  gap: 16px;
}
.totalCount {
  color: #4f46e5;
  font-size: 14px;
}

/* 添加按钮 */
.addBtn {
  font-size: 32px;
  background: linear-gradient(135deg, #4f46e5, #6366f1, #818cf8);
  position: absolute;
  width: 46px;
  height: 46px;
  text-align: center;
  line-height: 46px;
  color: #fff;
  border-radius: 50%;
  bottom: 2px;
  right: 40px;
  box-shadow: 0 4px 16px rgba(79, 70, 229, 0.4);
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}
.addBtn:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 20px rgba(79, 70, 229, 0.5);
}
.addBtn:active {
  transform: scale(0.98);
}

/* 弹窗通用 */
.overlayWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.add_user_overlay {
  width: 340px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.15);
  padding: 20px;
  box-sizing: border-box;
  overflow: hidden;
}
.add_userType {
  display: flex;
  border-bottom: 1px solid #e4e8ef;
}
.typeTab {
  flex: 1;
  text-align: center;
  padding: 12px 0;
  cursor: pointer;
  color: #888;
  font-size: 14px;
  transition: color 0.2s;
}
.typeTab:first-child {
  border-right: 1px solid #e4e8ef;
}
.typeTab.active {
  color: #4f46e5;
  font-weight: 600;
  border-bottom: 2px solid #4f46e5;
  margin-bottom: -1px;
}
.one_data {
  margin-top: 16px;
}
.one_data :deep(.van-field) {
  margin-bottom: 14px;
  border: 1px solid #e4e8ef;
  border-radius: 10px;
  font-size: 14px;
}
.one_data :deep(.van-field__control:focus) {
  border-color: #6366f1;
}
.submit {
  margin-top: 8px;
  background: linear-gradient(135deg, #4f46e5, #6366f1, #818cf8) !important;
  border: none !important;
  border-radius: 10px !important;
  font-weight: 600 !important;
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3) !important;
}
.submit:active {
  opacity: 0.9;
}
.fileUploader {
  font-size: 14px;
  margin: 22px 0;
  padding: 12px;
  border: 1px dashed #e4e8ef;
  border-radius: 8px;
  width: 100%;
  box-sizing: border-box;
}

/* Excel 预览列表 */
.allData_list {
  width: 80%;
  max-width: 700px;
  max-height: 85%;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.15);
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.allList_title {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  text-align: center;
  padding: 16px;
  border-bottom: 1px solid #e4e8ef;
  flex-shrink: 0;
}
.allData_list_close {
  position: absolute;
  right: 16px;
  top: 12px;
  font-size: 24px;
  color: #999;
  cursor: pointer;
  transition: color 0.2s;
  line-height: 1;
  z-index: 10;
}
.allData_list_close:hover {
  color: #666;
}
.excelTable {
  flex: 1;
  overflow: auto;
  padding: 0 16px;
}
.excelHeader {
  display: flex;
  background: #f7f8fa;
  padding: 10px 0;
  font-size: 13px;
  font-weight: 600;
  color: #555;
  position: sticky;
  top: 0;
}
.excelHeader span {
  flex: 1;
  text-align: center;
}
.excelRow {
  display: flex;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
  font-size: 13px;
}
.excelRow span {
  flex: 1;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.all_submit {
  margin: 16px;
  background: linear-gradient(135deg, #4f46e5, #6366f1, #818cf8) !important;
  border: none !important;
  border-radius: 8px !important;
  align-self: flex-end;
}
.van-loading {
  height: 90px;
  width: 90px;
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 4001;
  transform: translate(-50%, -50%);
}

/* 修改用户弹窗 */
.modify_user {
  width: 340px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.15);
  padding: 24px;
  box-sizing: border-box;    
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateY(-50%);

}
.modify_uer_title {
  font-size: 17px;
  font-weight: 600;
  color: #1a1a1a;
  text-align: center;
  margin-bottom: 20px;
}
.closeModify {
  position: absolute;
  right: 16px;
  top: 16px;
  font-size: 24px;
  color: #999;
  cursor: pointer;
  transition: color 0.2s;
  line-height: 1;
}
.closeModify:hover {
  color: #666;
}
.modify_user :deep(.van-field) {
  margin-bottom: 14px;
  border: 1px solid #e4e8ef;
  border-radius: 10px;
  font-size: 14px;
}
</style>
